module.exports = __webpack_public_path__ + "img/icon-pdf.91ee0068.svg";